import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { TextField, Button, Stack, Typography, FormControlLabel, Checkbox, Select, MenuItem } from '@mui/material'; // Added MenuItem

import { useAppContext } from '../context/AppContext';
import { useToast } from '../context/ToastContext';
import { getRoles } from '@testing-library/dom';

const defaultData = {
    firstName: '',
    lastName: '',
    username: '',
    email: '',
    password: '',
    passwordCheck: '',
    // organization: '',
    // manager: false,
    // role: ""
};

const UsersForm = ({ onSubmit, initialData }) => {

    const { id } = useParams();
    const navigate = useNavigate();
    const { showCorrect, showError } = useToast();
    const [form, setForm] = useState(initialData || {
        name: '',
        country: '',
        taxNumber: '',
        username: '',
        password: '',
        passwordCheck: '',
    });

    const { getUser, createUser } = useAppContext();

    useEffect(() => {
        const effectAsync = async () => {
            if (initialData) {
                setForm(defaultData);
            } else {
                setForm(defaultData);
            }
        }
        effectAsync();
    }, []);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleChangeSelect = (e) => {

        console.log("handleChangeSelect", e.target.name, e.target.value)
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleCheckboxChange = (e) => {

        console.log("handleCheckboxChange", e.target.name, e.target.checked)
        setForm({ ...form, [e.target.name]: e.target.checked });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (form.password === "") {
            alert('Password cannot be empty');
            return;
        }

        if (form.password !== form.passwordCheck) {
            alert('Passwords do not match');
            return;
        }

        try {
            await createUser(form);
            showCorrect('User created successfully');
            navigate('/users');
        } catch (err) {
            console.error(err);
            showError(`Error creating user: ${err.message}`);
        }

    };

    return (
        <form onSubmit={handleSubmit} >
            <Typography variant="h6">Create User</Typography>
            <Typography variant="p">This action will create a Customer and a BRI inside OnePlatform.</Typography>
            <Stack spacing={2} direction="column" sx={{ my: 2 }}>
                <Typography variant="h6">Customer Information</Typography>
                <TextField
                    name="name"
                    value={form.name}
                    placeholder='Customer Name'
                    onChange={handleChange}
                    fullWidth
                />
                <TextField
                    name="country"
                    value={form.country}
                    placeholder='Country'
                    onChange={handleChange}
                    fullWidth
                />
                <TextField
                    name="taxNumber"
                    value={form.taxNumber}
                    placeholder='Tax Number'
                    onChange={handleChange}
                    fullWidth
                />
                <Typography variant="h6">User Information</Typography>
                <TextField
                    name="username"
                    value={form.username}
                    placeholder='Username'
                    onChange={handleChange}
                    fullWidth
                />
                <TextField
                    name="password"
                    type="password"
                    placeholder="Password"
                    value={form.password}
                    onChange={handleChange}
                    fullWidth
                />
                <TextField
                    placeholder="Password Repeat"
                    name="passwordCheck"
                    type="password"
                    value={form.passwordCheck}
                    onChange={handleChange}
                    fullWidth
                />

                <Button variant="contained" type="submit" fullWidth>
                    Create User
                </Button>
            </Stack>
        </form>
    );
};

export default UsersForm;
